import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { initAppZoom } from "./utils/appZoom";

// Scale the UI down on screens narrower than the 1920px design (see appZoom.ts).
initAppZoom();

/* ===============================
   GLOBAL ERROR HANDLERS (PROD)
================================ */

// Catch unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);

  // Optional: show user-friendly message
  // alert("Something went wrong. Please refresh the page.");
});

// Catch synchronous runtime errors
window.addEventListener("error", (event) => {
  console.error("Global runtime error:", {
    message: event.message,
    source: event.filename,
    line: event.lineno,
    column: event.colno,
    error: event.error,
  });
});

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
